import { LoaderIcon } from '../../loader-icon';

type Props = {
  loading: boolean;
};

export const InputLoader = ({ loading }: Props) => {
  return loading && <LoaderIcon size="medium" />;
};
